export const getLanguageDirection = (lng = 'en') => {
  const dir = lng === 'ar' || lng === 'he' ? 'rtl' : 'ltr'
  return dir
}
